import React from 'react';
import { Shield, Zap } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function MechanismSection() {
  return <AnimatedSection className="py-24 bg-navy-900 relative px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-69">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-400/5 rounded-full blur-[100px] pointer-events-none" data-id="element-70" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-71">
        <div className="inline-flex items-center justify-center p-3 bg-gold-400/10 rounded-full mb-8 border border-gold-400/20" data-id="element-72">
          <Shield className="w-8 h-8 text-gold-400" data-id="element-73" />
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8" data-id="element-74">
          La solución no es la fuerza de voluntad, es el{' '}
          <span className="text-gold-400" data-id="element-75">Sistema de Inversión Invisible</span>
        </h2>

        <div className="bg-navy-800/80 backdrop-blur-sm border border-gold-400/20 p-8 sm:p-12 rounded-3xl shadow-2xl relative" data-id="element-76">
          <Zap className="absolute top-0 right-0 w-32 h-32 text-gold-400/5 -translate-y-1/2 translate-x-1/4" data-id="element-77" />

          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed text-left" data-id="element-78">
            En lugar de luchar contra tus ganas de gastar, configuramos una
            arquitectura técnica donde tu dinero se protege de ti mismo. Es una
            estrategia de{' '}
            <strong className="text-gold-400 font-bold text-2xl px-2" data-id="element-79">
              "fricción inversa"
            </strong>{' '}
            que automatiza tu crecimiento financiero para que ocurra en segundo
            plano, sin que tengas que tomar decisiones diarias ni sentir que te
            estás privando de vivir.
          </p>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/30 to-transparent" data-id="element-80" />
    </AnimatedSection>;
}